export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact"])},
        "shortIntro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We develop your software of tomorrow."])},
        "tellMeMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tell Me More"])}
      },
      "de": {
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])},
        "shortIntro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wir entwickeln Ihre Software von morgen."])},
        "tellMeMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr erfahren"])}
      }
    }
  })
}
